import {
    NinchatCallAction,
    NinchatCallActionPayload,
    clientActionTypes,
} from './types'

export const call = (payload: NinchatCallActionPayload): NinchatCallAction => ({
    payload,
    type: clientActionTypes.CALL,
})
